import { createContext, useContext, useState } from "react"
import { intialData } from "./initial";

export const action = createContext();

export default function Action ({children}) {
    const { initResetPayOnline } = useContext(intialData);

    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [enablePayOnline, setEnablePayOnline] = useState(initResetPayOnline);
    
    const parent = {
        errorMessage, 
        setErrorMessage,
        successMessage, 
        setSuccessMessage,
        editMode, 
        setEditMode,
        enablePayOnline, 
        setEnablePayOnline,
        initResetPayOnline,
    }
    return <action.Provider value={parent}>{children}</action.Provider>
    
}